module.exports = __webpack_public_path__ + "386487d6f353578e4aa71d865add7068.svg";